import { Button, TextField } from "@mui/material";
import { Backend } from "../services/Backend";
import { useState } from "react";
import { SuccessToast } from "../utils/utils";
import { useNavigate } from "react-router-dom";

export default function NewMessagePage() {
  const navigate = useNavigate();

  const [message, setMessage] = useState("");
  const [error, setError] = useState(false);
  const handleSend = () => {
    setError(false);
    if (message.length === 0) {
      setError(true);
      return;
    }

    Backend.post('message', { text: message })
      .then(res => {
        SuccessToast("Message sent successfully. Redirecting to messages page...");
        setTimeout(() => {
          navigate("/dashboard/messages");
        }, 2000);
      })
      .catch(err => {
        console.log(err);
      });
  }

    return (
        <div>
            <h1>New message</h1>
            <br/>
            <TextField id="outlined-basic" label="Enter your message" variant="outlined" multiline rows={5} fullWidth className="w-[700px]" error={error} helperText={error ? "Message cannot be empty" : ""} onChange={(e) => setMessage(e.target.value)}/>
            <br/>
            <br/>
            <Button variant="contained" color="primary" onClick={handleSend}>Send</Button>
        </div>
    );
}
